document.addEventListener('DOMContentLoaded', function() {
    /* Real slide count before tns clones the list (loop mode) — one dot per recipe */
    var realCount = document.querySelectorAll('.recipes-slider .recipes_slider .slide').length;

    /* Arrows are opt-in (schema "show_arrows"): when the container isn't
       rendered, tell tns not to generate its default controls either. */
    var controlsEl = document.querySelector('.recipes-slider .recipes-slider-controls');

    var slider = tns({
        container: '.recipes-slider .recipes_slider',
        slideBy: 1,
        /* Mobile (Figma 393): centered card with both neighbours peeking —
           items 1 + symmetric edgePadding + loop, same trick as
           pdp-recipes-2026. Desktop breakpoints reset edgePadding to 0. */
        edgePadding: 74,
        gutter: 17,
        center: false,
        controls: controlsEl ? true : false,
        controlsContainer: controlsEl || false,
        nav: false,
        autoplay: true,
        autoplayTimeout: 7000,
        autoplayButton: false,
        autoplayButtonOutput: false,    
        loop: true,
        rewind: false,
        autoplayHoverPause: true,
        mouseDrag: true,
        touch: true,
        preventScrollOnTouch: 'force',
        swipeAngle: false,
        responsive: {
            1200: {
                items: 2.8064,
                gutter: 37,
                fixedWidth: false
            },
            990: {
                items: 2,
                gutter: 18,
                fixedWidth: false
            },
            769: {
                items: 1,
                fixedWidth: false,
                edgePadding: 0,
                gutter: 10
            },
            480: {
                items: 1,
                fixedWidth: false,
                edgePadding: 85,
                gutter: 17
            }
        }
    });

    /* Custom pagination dots (shown on mobile via CSS), same pattern as
       pdp-recipes-2026: tns nav stays off, we render one dot per real slide
       and keep it in sync through indexChanged. */
    var dotsContainer = document.querySelector('.recipes-slider .recipes-slider-dots');
    if (dotsContainer && realCount > 1) {
        var navContainer = document.createElement('div');
        navContainer.className = 'tns-nav custom-nav';

        for (var i = 0; i < realCount; i++) {
            var button = document.createElement('button');
            button.setAttribute('data-nav', i);
            button.setAttribute('aria-label', 'Slide ' + (i + 1));
            button.type = 'button';
            if (i === 0) button.classList.add('tns-nav-active');
            navContainer.appendChild(button);
        }

        dotsContainer.appendChild(navContainer);

        slider.events.on('indexChanged', function(info) {
            var realIndex = (info.displayIndex - 1) % realCount;
            navContainer.querySelectorAll('button').forEach(function(btn, idx) {
                btn.classList.toggle('tns-nav-active', idx === realIndex);
            });
        });

        navContainer.addEventListener('click', function(e) {
            if (e.target.tagName === 'BUTTON') {
                slider.goTo(parseInt(e.target.getAttribute('data-nav'), 10));
            }
        });
    }

    function equalizeSlideHeights() {
        const slides = document.querySelectorAll('.recipes-slider .recipes_slider .slide');
        const slideTexts = document.querySelectorAll('.recipes-slider .recipes_slider .slide .slide_text');
        
        let maxHeight = 0;
        
        slideTexts.forEach(function(text) {
            text.style.height = 'auto';
        });
        
        slideTexts.forEach(function(text) {
            const height = text.offsetHeight;
            if (height > maxHeight) {
                maxHeight = height;
            }
        });
        
        slideTexts.forEach(function(text) {
            text.style.height = maxHeight + 'px';
        });
    }

    setTimeout(equalizeSlideHeights, 100);
    
    window.addEventListener('resize', function() {
        equalizeSlideHeights();
    });
    
    slider.events.on('indexChanged', function() {
        setTimeout(equalizeSlideHeights, 50);
    });
});